export const UPDATE_TRIGGERS = 'app/Dialog/UPDATE_TRIGGERS';
export const PHONE_VERIFICATION_DIALOG = 'PhoneVerificationDialog';
